import api from "../../config/axios";


class BankDetailsService {
    async addBankDetails(data: { bank_name: string, account_holder_name: string, account_number: string, ifsc_code: string }) {
        const response = await api.post('/bank-details/add', data);
        return response.data;
    }

    async updateBankDetails(data: { bank_name: string, account_holder_name: string, account_number: string, ifsc_code: string }) {
        const response = await api.put('/bank-details/update', data);
        return response.data;
    }

    async getBankDetails() {
        const response = await api.get('/bank-details');
        return response.data;
    }
}

const bankDetailsService = new BankDetailsService();
export default bankDetailsService;
